import { useEffect, useState } from "react";
import client from "@/lib/apiClient";

// Default fallback if the geo endpoint fails.
const DEFAULT = { country: "IN", currency: "INR", symbol: "₹", locale: "en-IN", fx_from_inr: 1.0 };

let cache = null;

/**
 * useCurrency — returns { currency, symbol, locale, fx_from_inr, format(inrAmount) }
 * The `format(inr)` helper converts an INR price to the user's local currency and
 * formats it via Intl.NumberFormat for their locale.
 */
export function useCurrency() {
  const [c, setC] = useState(cache || DEFAULT);

  useEffect(() => {
    if (cache) return;
    client
      .get("/geo/currency")
      .then(({ data }) => {
        cache = data;
        setC(data);
      })
      .catch(() => {});
  }, []);

  const format = (inrAmount) => {
    const converted = Number(inrAmount) * (c.fx_from_inr || 1);
    // JPY / IDR / etc. don't use decimals — Intl handles that automatically.
    try {
      return new Intl.NumberFormat(c.locale || "en-IN", {
        style: "currency",
        currency: c.currency || "INR",
        maximumFractionDigits: c.currency === "JPY" || c.currency === "IDR" ? 0 : 2,
      }).format(converted);
    } catch {
      return `${c.symbol || "₹"}${converted.toFixed(2)}`;
    }
  };

  return { ...c, format };
}
